"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var idm_ng_controls_1 = require("@synisys/idm-ng-controls");
var abstract_destruction_subject_1 = require("../abstract-destruction-subject");
var operators_1 = require("rxjs/operators");
var zip_1 = require("rxjs/observable/zip");
require("./sis-hint-settings.component.scss");
var SisHintSettingsComponent = /** @class */ (function (_super) {
    __extends(SisHintSettingsComponent, _super);
    function SisHintSettingsComponent(languageService, currentLanguageProvider) {
        var _this = _super.call(this) || this;
        _this.languageService = languageService;
        _this.currentLanguageProvider = currentLanguageProvider;
        _this.valueChange = new core_1.EventEmitter();
        _this.isReady = false;
        return _this;
    }
    Object.defineProperty(SisHintSettingsComponent.prototype, "hint", {
        get: function () {
            return this._hint;
        },
        set: function (hint) {
            this._hint = hint;
            this.valueChange.emit(hint);
        },
        enumerable: true,
        configurable: true
    });
    SisHintSettingsComponent.prototype.ngOnInit = function () {
        var _this = this;
        zip_1.zip(this.languageService.getInputLanguages(), this.currentLanguageProvider.getCurrentLanguage())
            .pipe(operators_1.takeUntil(this.destroySubject$))
            .subscribe(function (data) {
            _this.languages = data[0];
            _this.currentLanguageId = data[1].getId();
            if (!_this._hint) {
                _this.hint = idm_crosscutting_concepts_frontend_1.MultilingualString.newBuilder()
                    .withValueForLanguages(_this.languages.map(function (language) {
                    return language.getId();
                }), '')
                    .build();
            }
            _this.isReady = true;
        }, function (err) { return console.error(err); });
    };
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], SisHintSettingsComponent.prototype, "valueChange", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", idm_crosscutting_concepts_frontend_1.MultilingualString),
        __metadata("design:paramtypes", [idm_crosscutting_concepts_frontend_1.MultilingualString])
    ], SisHintSettingsComponent.prototype, "hint", null);
    __decorate([
        core_1.ViewChild('hintInput'),
        __metadata("design:type", idm_ng_controls_1.MultilingualComponent)
    ], SisHintSettingsComponent.prototype, "hintInput", void 0);
    SisHintSettingsComponent = __decorate([
        core_1.Component({
            moduleId: module.id + '',
            selector: 'sis-hint-setting',
            template: require('./sis-hint-settings.component.html'),
        })
        /**
         * @deprecated - use sis-ng-hint-settings from ng-controls
         */
        ,
        __metadata("design:paramtypes", [idm_message_language_service_client_js_1.LanguageService,
            idm_session_data_provider_api_js_1.CurrentLanguageProvider])
    ], SisHintSettingsComponent);
    return SisHintSettingsComponent;
}(abstract_destruction_subject_1.AbstractDestructionSubject));
exports.SisHintSettingsComponent = SisHintSettingsComponent;
//# sourceMappingURL=sis-hint-settings.component.js.map